import { useState } from "react";
import labels from "../../utils/labels";
import TabButton from "../UI/tab/TabButton";
import ColouredRoundWrapper from "../UI/wrappers/ColouredRoundWrapper"
import EmployeeSettingsTab from "./EmployeeSettingsTab";
import drawerStyles from "../../styles/drawer.module.css";

type EmployeeDrawerTabsType = "EMPLOYEE" | "PREFERENCES";
type EmployeeDrawerTabObject = { title: string; type: EmployeeDrawerTabsType };

const EmployeeDrawerContent = ({
  onEmployeeUnsavedEdit
}: {
  onEmployeeUnsavedEdit: (hasChanges: boolean) => void
}) => {
  const [selected, setSelected] = useState<EmployeeDrawerTabsType>("EMPLOYEE");

  const tabBarValues: EmployeeDrawerTabObject[] = [
    { title: labels.employeeSettings, type: "EMPLOYEE" },
    { title: labels.citizenPreferences, type: "PREFERENCES" },
  ]

  return (
    <div className={drawerStyles.drawerContent}>
      <ColouredRoundWrapper
        bgColor="var(--col-surface-secondary)"
        width="100%"
      >
        {tabBarValues.map((tab, index) => (
          <TabButton
            key={index}
            fullWidth
            tabTitle={tab.type === "EMPLOYEE" ? labels.employeeSettings : labels.citizenPreferences}
            onClick={() => setSelected(tab.type)}
            selected={selected === "EMPLOYEE" ? labels.employeeSettings : labels.citizenPreferences}
          />
        ))}
      </ColouredRoundWrapper>

      {selected === "EMPLOYEE" && <EmployeeSettingsTab onEmployeeUnsavedEdit={onEmployeeUnsavedEdit} />}
      {selected === "PREFERENCES" && (<p>Preferences tab</p>)}
    </div>
  )
}

export default EmployeeDrawerContent